// extracted by mini-css-extract-plugin
module.exports = {"base":"PageHeaderAction-module-base","isActive":"PageHeaderAction-module-is-active","isInteractive":"PageHeaderAction-module-is-interactive"};